export enum ShareType {
    ANNUAL_REPORT_SHARE = 'ANNUAL_REPORT',
}
